(() => {
  if (window.digiMarketplaceCartInitialized) return;

  window.digiMarketplaceCartInitialized = true;

  const getCart = (target) => {
    return target?.closest("[data-digi-marketplace-cart]");
  };

  const resetDiscountFields = () => {
    document
      .querySelectorAll(
        "#halo-cart-sidebar cart-discount-component"
      )
      .forEach((component) => {
        component.dataset.open = "closed";

        const form = component.querySelector(
          ".discount-form"
        );

        const openButton = component.querySelector(
          ".insert-code"
        );

        const input = component.querySelector(
          'input[name="discount"]'
        );

        const error = component.querySelector(
          ".discount-error"
        );

        if (form) {
          form.setAttribute(
            "aria-hidden",
            "true"
          );
        }

        if (openButton) {
          openButton.textContent = "Inserir código";
        }

        if (input) {
          input.value = "";
        }

        if (error) {
          error.hidden = true;
        }
      });
  };

const resetShippingFields = () => {
  document
    .querySelectorAll(
      "#halo-cart-sidebar cart-shipping-component"
    )
    .forEach((component) => {
      const hasSelectedShipping =
        component.classList.contains(
          "shipping-component-applied"
        );

      const form = component.querySelector(
        ".shipping-component-form"
      );

      const openButton = component.querySelector(
        ".insert-cep"
      );

      const input = component.querySelector(
        'input[name="shipping-component"]'
      );

      const error = component.querySelector(
        ".shipping-component-error"
      );


      /*
       * IMPORTANTE:
       * No frete não podemos usar data-open="closed",
       * porque o CSS atual esconde .frete-wrapper inteiro.
       *
       * Voltamos ao estado inicial do componente:
       * - linha "Frete" visível
       * - botão "Calcule seu frete" visível
       * - formulário escondido
       */
      if (!hasSelectedShipping) {
        component.removeAttribute("data-open");
      }


      if (form) {
        form.style.opacity = "";
        form.style.visibility = "";
      }


      if (openButton && !hasSelectedShipping) {
        openButton.textContent = "Calcule seu frete";
      }


      if (input) {
        input.value = "";
      }


      if (error) {
        error.hidden = true;
        error.textContent = "";
      }
    });
};

  const resetMarketplaceFields = () => {
    resetDiscountFields();
    resetShippingFields();
  };

  const openSummary = (cart) => {
    if (!cart) return;

    resetMarketplaceFields();

    const sheet = cart.querySelector(
      "[data-digi-marketplace-sheet]"
    );

    const overlay = cart.querySelector(
      "[data-digi-marketplace-overlay]"
    );

    const trigger = cart.querySelector(
      "[data-digi-marketplace-open]"
    );

    if (!sheet || !overlay) return;

    sheet.hidden = false;
    overlay.hidden = false;

    cart.classList.add("is-open");

    trigger?.setAttribute(
      "aria-expanded",
      "true"
    );

    document.documentElement.classList.add(
      "digi-marketplace-cart-summary-open"
    );
  };

  const closeSummary = (cart) => {
    if (!cart) return;

    const sheet = cart.querySelector("[data-digi-marketplace-sheet]");
    const overlay = cart.querySelector("[data-digi-marketplace-overlay]");
    const trigger = cart.querySelector("[data-digi-marketplace-open]");

    if (!sheet || !overlay) return;

    sheet.hidden = true;
    overlay.hidden = true;

    cart.classList.remove("is-open");

    trigger?.setAttribute("aria-expanded", "false");

    document.documentElement.classList.remove(
      "digi-marketplace-cart-summary-open"
    );

    resetMarketplaceFields();
  };

  document.addEventListener("click", (event) => {

    const couponButton = event.target.closest(
      "[data-digi-marketplace-coupon-apply]"
    );

    if (couponButton) {
      event.preventDefault();

      const cart = getCart(couponButton);

      if (!cart) return;

      const couponCode = couponButton.dataset.couponCode?.trim();

      if (!couponCode) {
        return;
      }


      let discountComponent = null;


      /*
      * Se o botão estiver dentro do resumo aberto,
      * usa o formulário de cupom do próprio resumo.
      */
      const sheet = couponButton.closest(
        ".digi-marketplace-cart__sheet"
      );

      if (sheet) {
        discountComponent = sheet.querySelector(
          ".digi-marketplace-cart__coupon cart-discount-component"
        );
      }


      /*
      * Caso esteja fora do resumo,
      * usa o formulário superior do carrinho.
      */
      if (!discountComponent) {
        discountComponent = cart.querySelector(
          ".digi-marketplace-cart__coupon-top cart-discount-component"
        );
      }


      if (!discountComponent) {
        return;
      }


      const discountInput = discountComponent.querySelector(
        'input[name="discount"]'
      );

      const discountForm = discountComponent.querySelector(
        ".discount-form"
      );


      if (!discountInput || !discountForm) {
        return;
      }


      /*
      * Preenche automaticamente com o código
      * configurado no editor do tema.
      */
      discountInput.value = couponCode;


      /*
      * Dispara o submit normal do componente.
      * Assim continuamos usando cart-tools.js
      * e não duplicamos lógica de desconto.
      */
      couponButton.disabled = true;
      couponButton.classList.add("is-loading");
      discountForm.requestSubmit();

      return;
    }

    const openButton = event.target.closest(
      "[data-digi-marketplace-open]"
    );

    if (openButton) {
      event.preventDefault();

      openSummary(getCart(openButton));

      return;
    }

    const closeButton = event.target.closest(
      "[data-digi-marketplace-close]"
    );

    if (closeButton) {
      event.preventDefault();

      closeSummary(getCart(closeButton));

      return;
    }

    const overlay = event.target.closest(
      "[data-digi-marketplace-overlay]"
    );

    if (overlay) {
      closeSummary(getCart(overlay));
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;

    const openCart = document.querySelector(
      "[data-digi-marketplace-cart].is-open"
    );

    closeSummary(openCart);
  });

  const cartSidebarObserver = new MutationObserver(() => {
    const isCartOpen =
      document.body.classList.contains(
        "cart-sidebar-show"
      );

    if (!isCartOpen) {
      resetMarketplaceFields();
    }
  });

  cartSidebarObserver.observe(
    document.body,
    {
      attributes: true,
      attributeFilter: ["class"],
    }
  );

})();